export const RECOVERY_REQUEST = 'RECOVERY_REQUEST';
export const RECOVERY_CHANGE_REQUEST = 'RECOVERY_CHANGE_REQUEST';
export const RECOVERY_SUCCESS = 'RECOVERY_SUCCESS';
export const RECOVERY_ERROR = 'RECOVERY_ERROR';
export const RECOVERY_EMAIL_REQUEST = 'RECOVERY_EMAIL_REQUEST';
